import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import { default as PracticeLocationsReducer } from './PracticeLocations'
import { default as BookmarkReducer } from './bookmark'
import { default as CostsReducer } from './costs'
import { default as DetailReducer } from './detail'
import { default as FilterReducer } from './filter'
import { default as RecentlyViewedReducer } from './recentlyViewed'
import { default as ReviewReducer } from './review'
import { default as SearchReducer } from './search'
import { default as SpecialtiesReducer } from './specialties'
import { default as SuggestReducer } from './suggest'

export * from './bookmark'
export * from './costs'
export * from './detail'
export * from './filter'
export * from './PracticeLocations'
export * from './recentlyViewed'
export * from './review'
export * from './search'
export * from './specialties'
export * from './suggest'

export const types = {
  UPDATE_PRACTICE_LOCATION_PROVIDER_BOOKMARK:
    'doctor/UPDATE_PRACTICE_LOCATION_PROVIDER_BOOKMARK',
  ...makeApiTypes('FETCH_PRACTICE_LOCATION_PROVIDERS', 'doctor'),
  ...makeApiTypes('FETCH_LOCATION_CONTACT_INFO', 'doctor'),
  CLEAR_PRACTICE_LOCATION_PROVIDERS: 'doctor/CLEAR_PRACTICE_LOCATION_PROVIDERS',
  // ---
  ...makeApiTypes('FETCH_BOOKMARKS', 'doctor'),
  ...makeApiTypes('BOOKMARK_DOCTOR', 'doctor'),
  ...makeApiTypes('UNBOOKMARK_DOCTOR', 'doctor'),
  // ---
  ...makeApiTypes('FETCH_DOCTOR_COSTS', 'doctor'),
  ...makeApiTypes('FETCH_DOCTOR_COSTS_BY_QUERY', 'doctor'),
  FLUSH_DOCTOR_COSTS: 'doctor/FLUSH_DOCTOR_COSTS',
  // ---
  ...makeApiTypes('FETCH_DOCTOR_DETAIL', 'doctor'),
  CLEAR_DOCTOR_DETAIL: 'doctor/CLEAR_DOCTOR_DETAIL',
  // ---
  ...makeApiTypes('FETCH_SPECIALTIES', 'doctor'),
  RESET_SPECIALTIES: 'doctor/RESET_SPECIALTIES',
  // ---
  ...makeApiTypes('FETCH_RECENTLY_VIEWED', 'doctor'),
  // ---
  ...makeApiTypes('FETCH_MEMBER_REVIEW', 'doctor'),
  ...makeApiTypes('FETCH_REVIEWS', 'doctor'),
  ...makeApiTypes('CREATE_REVIEW', 'doctor'),
  ...makeApiTypes('UPDATE_REVIEW', 'doctor'),
  ...makeApiTypes('DELETE_REVIEW', 'doctor'),
  FLUSH_DOCTOR_REVIEWS: 'doctor/FLUSH_DOCTOR_REVIEWS',
  RESET_MEMBER_REVIEW: 'doctor/RESET_MEMBER_REVIEW',
  // ---
  ...makeApiTypes('FETCH_DOCTORS', 'doctor'),
  ...makeApiTypes('FETCH_DOCTOR_FILTERS', 'doctor'),
  RESET_DOCTOR_SEARCH: 'doctor/RESET_DOCTOR_SEARCH',
  // ---
  ...makeApiTypes('FETCH_SUGGESTIONS', 'doctor'),
}

export const initialState = {
  searchResults: {
    page: null,
    size: 5,
    isLastPageReached: false,
    busy: false,
    error: '',
    entities: [],
  },
  doctorFilters: {
    busy: false,
    error: '',
    filters: {},
  },
  suggestions: {
    busy: false,
    error: '',
    entities: [],
  },
  bookmarks: {
    busy: false,
    error: '',
    entities: [],
  },
  reviews: {
    busy: false,
    error: '',
    entities: [],
  },
  memberReview: {
    busy: false,
    error: '',
    review: {},
  },
  doctorDetails: {
    busy: false,
    error: '',
    details: {},
  },
  recentlyViewed: {
    busy: false,
    error: '',
    entities: [],
  },
  specialties: {
    busy: false,
    error: '',
    page: null,
    size: 12,
    isLastPageReached: false,
    entities: [],
  },
  costs: {
    busy: false,
    page: null,
    size: 25,
    isLastPageReached: false,
    entities: [],
  },
  practiceLocationProviders: {
    busy: false,
    error: '',
    entity: [],
  },
  practiceLocations: { busy: false, error: '', entities: [] },
}

export default reduceReducers(
  BookmarkReducer,
  CostsReducer,
  DetailReducer,
  FilterReducer,
  PracticeLocationsReducer,
  RecentlyViewedReducer,
  ReviewReducer,
  SearchReducer,
  SpecialtiesReducer,
  SuggestReducer,
  // last arg MUST be shared state
  initialState,
)
